import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { pluralizeNext } from "shared/Pluralize";

import { ScanRunsListItem } from "../../../types";

const ScanRunsTableTotalResourcesCell = ({
  item: run,
  ...cellProps
}: TableSimpleCellProps<ScanRunsListItem>) => (
  <TableSimpleCell {...cellProps}>
    {run.resourceCount ? (
      <TableCellText>{pluralizeNext(run.resourceCount, "resource")}</TableCellText>
    ) : (
      <TableCellEmpty />
    )}
  </TableSimpleCell>
);

export default ScanRunsTableTotalResourcesCell;
